import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { ReleasedProductVariants } from "../../../../core/models/shared/releasedProductVariants";
import { TableModule } from "primeng/table";
import { SamplepoListingService } from "../../../../core/services/samplepo-listing.service";
import { ButtonModule } from "primeng/button";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";

@UntilDestroy()
@Component({
  selector: "jni-variants-listing",
  templateUrl: "./variants-listing.component.html",
  styleUrls: ["./variants-listing.component.scss"],
  imports: [TableModule, ButtonModule, CardModule, InputTextModule],
})
export class VariantsListingComponent implements OnInit {
  filterVariantsListing: ReleasedProductVariants[] = [];

  @Input() itemNumber = "";
  @Input() productName = "";
  @Output() closeModalEvent = new EventEmitter();

  constructor(private _samplepoListingService: SamplepoListingService) {}

  ngOnInit(): void {
    this.getAllVariants();
  }

  getAllVariants() {
    this._samplepoListingService
      .getAllVariants()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data) {
            this.filterVariantsListing = res.data.filter(
              x => x.itemIdD365 == this.itemNumber && x.poStopped === "No"
            );
          }
        },
      });
  }

  onCloseModal() {
    this.closeModalEvent.emit();
  }
}
